module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--home main--full-height"
  }, [(_vm.isIe) ? _c('module-modal', {
    attrs: {
      "modal": _vm.oldBrowser
    }
  }) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "confirm",
      "mode": "out-in"
    }
  }, [(_vm.cancelling === false) ? _c('div', {
    key: "main",
    staticClass: "group group--last"
  }, [(_vm.userLoggedOut) ? _c('module-pop-up', _vm._b({}, 'module-pop-up', _vm.forcedLogout, false)) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid--home"
  }, [_c('div', {
    staticClass: "grid__item grid__item--2 pr hide-below-medium"
  }, [_c('div', {
    staticClass: "home__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--2"
  }, [_c('transition', {
    attrs: {
      "name": "intake",
      "mode": "out-in"
    }
  }, [(_vm.org && _vm.org.username || _vm.isAuthenticated) ? _c('text-carousel', {
    attrs: {
      "phrase": _vm.searchIsOpen ? {
        id: 1,
        headline: 'Find your company',
        sub_headline: 'Visit your company’s Beacon portal to log in and access your Carelon Wellbeing services.',
      } : _vm.activeHomepagePhrase
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt0 mb2"
  }, [(!_vm.org.username) ? _c('blockquote', {
    staticClass: "mb"
  }, [_c('p', {
    staticClass: "p mt0 mb0"
  }, [_vm._v("\n                Please contact your benefits administrator for assistance.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.copy.buttonShow) ? _c('module-button', {
    attrs: {
      "button": _vm.copy.buttonType,
      "size": "s"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleButtonAction(_vm.copy)
      }
    }
  }, [_vm._v(_vm._s(_vm.copy.button) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.copy.button === "Continue") ? _c('module-button', {
    attrs: {
      "button": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.restartIntake(_vm.copy)
      }
    }
  }, [_vm._v("Restart")]) : _vm._e(), _vm._v(" "), (_vm.copy.showCancel && _vm.isAuthenticated) ? _c('module-button', {
    staticClass: "mr-tiny",
    attrs: {
      "loading": _vm.cancelling,
      "button": "secondary",
      "size": "s"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rescheduleAppointment()
      }
    }
  }, [_vm._v("\n              Reschedule\n            ")]) : _vm._e(), _vm._v(" "), (_vm.copy.showCancel && _vm.isAuthenticated) ? _c('module-button', {
    staticClass: "mr-tiny",
    attrs: {
      "loading": _vm.cancelling,
      "button": "secondary",
      "size": "s"
    },
    nativeOn: {
      "click": function($event) {
        return (function () {
          _vm.cancelling = 'confirm';
        }).apply(null, arguments)
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated && _vm.appointments.length > 0) ? _c('module-button', {
    attrs: {
      "loading": _vm.cancelling,
      "link": "appointments",
      "button": "primary",
      "size": "s"
    }
  }, [_vm._v("\n              View All Appointments\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.org.introduction) ? _c('blockquote', {
    staticClass: "mb"
  }, [_c('p', {
    staticClass: "p mt0 mb0"
  }, [_vm._v(_vm._s(_vm.org.introduction))])]) : _vm._e(), _vm._v(" "), _c('module-nav-links', {
    attrs: {
      "search": _vm.isRootOrg,
      "services": _vm.services,
      "copy": _vm.copy,
      "hr": false
    },
    on: {
      "isSearching": _vm.isSearching
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "home__image hide-above-medium"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.cancelling === 'confirm') ? [_c('div', {
    key: "confirm",
    staticClass: "bg-primary ovh df aic jcc pd"
  }, [_c('div', [_c('h1', {
    staticClass: "c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Are you sure you want to cancel?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("\n            You might not be able to get another appointment at the same time\n            or with the same counselor.\n          ")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelAppointment(_vm.copy.id)
      }
    }
  }, [_vm._v("\n            Yes, Cancel\n          ")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return (function () {
          _vm.cancelling = false;
        }).apply(null, arguments)
      }
    }
  }, [_vm._v("\n            No, never mind\n          ")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.cancelling === 'loading') ? _c('ui-module-loader', {
    key: "loader",
    attrs: {
      "messages": [
        'Please give us a moment to cancel',
        'All set, your appointment has been cancelled'
      ]
    },
    on: {
      "messages-complete": _vm.onMessagesComplete
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69409192"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 430
// module chunks = 0